import { AI_FEEDBACK_TEXT_MAX, AiRunFeedbackPayload } from '../../core/models/ai.model';

/** Motivo que exige complemento escrito. */
export const AI_FEEDBACK_OTHER = 'outro';

/**
 * O que impede enviar a avaliação "não útil" (null = pode enviar). Mesmas regras do servidor:
 * motivo obrigatório, complemento até 300 caracteres e obrigatório em "Outro".
 */
export function feedbackProblem(reasonCode: string | null, reasonText: string): string | null {
  if (!reasonCode) return 'Escolha o motivo.';
  const text = reasonText.trim();
  if (reasonCode === AI_FEEDBACK_OTHER && !text) return 'Descreva o motivo.';
  if (text.length > AI_FEEDBACK_TEXT_MAX) {
    return `O detalhe pode ter até ${AI_FEEDBACK_TEXT_MAX} caracteres.`;
  }
  return null;
}

export function feedbackPayload(
  reasonCode: string,
  reasonText: string,
  rejectedActions: boolean
): AiRunFeedbackPayload {
  const text = reasonText.trim();
  return {
    useful: false,
    reason_code: reasonCode,
    reason_text: text || null,
    rejected_actions: rejectedActions,
  };
}

/**
 * Texto que volta para a revisão depois de recusar o resultado: vai no campo de instrução da nova
 * execução, para a IA saber o que corrigir.
 */
export function rejectionInstruction(
  reasonLabel: string | null,
  reasonText: string | null | undefined,
  previous?: string | null
): string {
  const detail = (reasonText ?? '').trim();
  const end = detail && !/[.!?]$/.test(detail) ? '.' : '';
  const line = `Resultado anterior recusado (${reasonLabel ?? 'não útil'})${detail ? `: ${detail}${end}` : '.'} Corrija isso nesta análise.`;
  const base = (previous ?? '').trim();
  return base ? `${base}\n${line}` : line;
}
